import { styled, Tab, TabProps, Tabs, TabsProps } from '@mui/material';

const TabBarComponent = styled((props: TabsProps) => (
    <Tabs
        {...props}
        slotProps={{
            indicator: {
                sx: {
                    display: 'block',
                    minHeight: '28px',
                    borderRadius: '9999px',
                    backgroundColor: '#FFF',
                    zIndex: 1,
                },
            },
        }}
    />
))({
    backgroundColor: '#ECECF0',
    width: 'fit-content',
    borderRadius: '9999px',
    padding: '3px',
});

const TabBarTab = styled((props: TabProps) => <Tab {...props} disableRipple />)({
    minHeight: '28px',
    padding: '4px 8px',
    lineHeight: '20px',
    borderRadius: '9999px',
    color: '#0A0A0A',
    zIndex: 2,
    '&.Mui-selected': {
        color: '#0A0A0A',
    },
});

const TabBar = Object.assign(TabBarComponent, {
    Tab: TabBarTab,
});

export { TabBar };
